export default {
    Search: {
        btns: {
            protein: '蛋白質',
            nucleotide: '核苷酸',
            nucleotideDb: '核苷酸資料庫',
            proteinDb: '蛋白質資料庫',
            upload: '上傳序列',
            delete: '删除',
            clear: '清除',
            addFragment: '添加片段',
        },
        propver: {
            reset: '重置',
            applyToAll: '套用到所有 query',
            Preferences: {
                qconv: {
                    1: '查詢覆蓋範圍設置越高，命中序列的相似度越高。',
                    2: '設置查詢覆蓋範圍以設定返回序列的最低匹配長度的百分比，若需要搜索整段序列，推薦設置高覆蓋範圍。',
                },
                gaps: {
                    1: '匹配間隙僅僅修改了序列對齊的BLAST分數，並不一定會增加或減少返回結果。',
                    2: '設置是否包含間隙進行匹配意味著您是否希望序列對齊結果中包含間隙。若序列中某些片段十分相似但被一些不匹配部分所隔開，則推薦開啟匹配間隙：',
                    3: '專利可以在一定的百分比範圍內保護序列，無論有無間隙，因此兩種模式都值得嘗試。',
                },
                evalue: {
                    1: 'E-Value期望閾值設置越高，返回結果可能越多。',
                    2: 'E-Value代表命中結構與查詢序列偶然相似的可能性。例如，如果查詢序列很短，則其偶然出現在序列不同位置的可能性將很高。 E-Value設置得越高，這種偶然性就越大。',
                },
                algorithm: {
                    megaBlast: '適用於比較非常相似的序列。',
                    blastn: '標準核苷酸檢索，在核苷酸庫中匹配核苷酸序列。',
                    blastnShort: '適用於長度短於50個核苷酸的短序列。',
                    blastxFast: '將待查詢的核苷酸序列翻譯成蛋白質序列，然後在蛋白質庫中進行匹配。',
                    blastpFast: '使用較長字長，相較於標準Blastp用時較短。',
                    blastp: '標準蛋白質檢索，在蛋白質庫中匹配蛋白質序列。',
                    blastpShort: '適用於長度短於30個氨基酸的短序列。',
                    tblastnFast:
                        '將待查詢的核苷酸庫中的核苷酸序列翻譯成蛋白質序列後，將待查詢的蛋白質與翻譯結果進行匹配。',
                },
                lowComplexRegion: '屏蔽查詢序列中的低復雜度區域。',
                defaultAlgorithm: '輸入短序列，演算法將調整為blast-short',
                slowWarning: '蛋白序列蒐索核酸庫會花費較長時間！',
                algorithmDescription: {
                    1: '<b>全局比對演算法</b>（例如Needleman-Wunsch方法）將兩個序列從頭到尾比對，每個序列中的每個字母只比對一次。',
                    2: '<b>局部比對演算法</b>（如 BLAST演算法）也可用於對兩個序列進行比對，但只對序列中具有相似性的部分進行比對。如果沒有相似性，則不會返回比對結果。',
                    3: '全局比對演算法只適用於大部分部份具有顯著相似性的序列，有時會返回更好的結果，尤其是對於短序列。',
                },
            },
        },
        labels: {
            refinements: '搜索選項',
            predicted: '序列類型:',
            database: '選擇資料庫:',
            advance: '高級設定 >',
            sequenceLength: '序列長度',
            preferences: '搜索偏好設置',
            countries: '國家',
            countriesTitle: '請選擇國家/組織/地區',
            similarity: '序列相似度 (%)',
            qconv: '査詢覆蓋範圍 (%)',
            gaps: '匹配間隙',
            evalue: 'E-Value',
            algorithm: '算法',
            matrix: '打分矩陣',
            wordSize: '匹配字長',
            wordSizeHold: '默認',
            gapCosts: '間隙罰分',
            matchScores: '匹配得分／ <br/> 錯配罰分',
            matchScoresNoWrap: '匹配得分／錯配罰分',
            proAutoAdjust:
                '自動調整短序列的搜索參數，若勾選此項，則在查詢等於或短於30個氨基酸的序列時自動調整到blastp-short算法。',
            nuAutoAdjust:
                '自動調整短序列的搜索參數，若勾選此項，則在查詢短於50個核苷酸的序列時自動調整到blastn-short算法。',
            threshold: '期望閾值',
            yes: '是',
            no: '否',
            queryIdentity: '查詢相似度 (%)',
            subjectIdentity: '目標相似度 (%)',
            subjectCoverage: '目標覆蓋範圍 (%)',
            subjectLength: '目標序列長度',
            subjectProteinLength: '目標序列長度（aa）',
            subjectNucLength: '目標序列長度（nt）',
            targetSeqLimit: '序列检索上限',
            targetSeqLimitTooltip: '请联系客服升级权限',
            millionOptionTooltip: '“序列檢索上限”為500,000或1,000,000時，檢索速度會很慢。如無特殊需要，可改為50,000',
            length: '長度',
            multi: '多段',
            lowComplexRegion: '忽略低複雜度區域',
            defaultAlgorithm: '默認算法',
            searchParameters: '搜索參數',
            algorithmSettings: '算法設置',
            databaseTitle: '數據庫',
            mismatch: '錯配數',
            algorithmType: '搜索算法',
            alignmentIdentity: '序列相似度 (%)',
            gapExtend: '間隙延伸懲罰',
            gapOpen: '間隙開放懲罰',
            scoreMatrix: '打分矩陣',
            algorithmTypes: {
                Blast: 'Blast算法',
                Nw: '全局比對算法',
            },
            nonShortSequence: '非短序列',
            shortSequence: '短序列',
        },
        explanation: {
            example: '示例',
            identityLength: '相似序列長度',
            alignLength: '對齊區域長度',
            queryLength: '查詢序列長度',
            subjectLength: '目標序列長度',
            scoreMatrixDefaultTip: '匹配得分和錯配懲罰僅在DEFAULT矩陣下生效',
        },
    },
};
